import { alpha, lighten } from "@mui/material/styles";

const RADIUS = 8;

// Nested Datagrid (settings.style.secondaryDatagrid & co.): light primary-tinted header with dark primary
// labels and a small primary bar on its left edge (the shadowBox accent in miniature), faint zebra rows
// in the same tint and rounded corners.
// The theme's main-Datagrid header sets a backgroundImage, so this one has to clear it.
export const secondaryDatagridStyle = ({ main, dark }, { textAlign, position } = {}) => ({
  borderRadius: `${RADIUS}px`,
  borderColor: alpha(main, 0.15),
  // Clip the square header/row corners to the rounded table. "auto", not "hidden": any non-visible overflow clips
  // the corners, and "auto" also lets a table wider than its box (student record, curriculum disciplines on a 14"
  // laptop) scroll sideways instead of cutting its last columns off. Nested tables are short, so losing the sticky
  // header here (the wrapper becomes the scroll container) is fine.
  "& .RaDatagrid-tableWrapper": { borderRadius: `${RADIUS}px`, overflow: "auto" },
  "& .RaDatagrid-headerCell": {
    // Opaque tint (not alpha) so the header reads the same over any background.
    backgroundColor: lighten(main, 0.9),
    backgroundImage: "none",
    color: dark,
    fontWeight: 700,
    fontSize: 12,
    paddingRight: "5px",
    paddingLeft: "10px",
    borderBottom: `1px solid ${alpha(main, 0.2)}`,
    ...(textAlign && { textAlign }),
    ...(position && { position }),
    "& .MuiTableSortLabel-root, & .MuiTableSortLabel-root:hover, & .MuiTableSortLabel-root.Mui-active, & .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon":
      { color: "inherit" },
  },
  // Left bar in the same vertical gradient as the shadowBox accent. A pseudo-element, since box-shadow and
  // borders can't take a gradient; header cells are sticky (or relative), so they position it.
  "& .RaDatagrid-headerCell:first-of-type::before": {
    content: '""',
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    width: 3,
    background: `linear-gradient(180deg, ${lighten(main, 0.45)} 0%, ${main} 45%, ${dark} 100%)`,
  },
  "& .RaDatagrid-rowOdd": { backgroundColor: lighten(main, 0.96) },
  "& .RaDatagrid-row:hover, & .MuiTableRow-hover:hover": { backgroundColor: alpha(main, 0.08) },
});
